import { icon } from "@/app/style/icons";
import { FormControl, Grid2, Typography, Radio, RadioGroup, FormControlLabel } from "@mui/material"

interface Option {
  label: string;
  value: string;
}

interface SettingsMultiselectProps {
  title: string;
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const SettingsMultiselect = ({ title, options, value, onChange, disabled = false }: SettingsMultiselectProps) => {
  return (
    <Grid2 container size={12} direction="column" spacing={1}>
      <Grid2>
        <Typography variant="subtitle2">{title}</Typography>
      </Grid2>
      <Grid2>
        <FormControl component="fieldset">
          <RadioGroup
            value={value}
            onChange={(e) => onChange(e.target.value)}
          >
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={
                  <Radio 
                    size="small"
                    icon={<icon.squareUnchecked style={{ fontSize: 18 }} />}
                    checkedIcon={<icon.squareChecked style={{ fontSize: 18 }} />}
                    color="secondary"
                    disabled={disabled}
                  />
                }
                label={option.label}
                disabled={disabled}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Grid2>
    </Grid2>
  )
}